import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.167 3.333L8 9.75l5.833-6.417H2.167zM4.722 4.5h6.562L8 8 4.722 4.5z",
		fillRule: "nonzero"
	}), /* @__PURE__ */ _jsx("path", { d: "M7.417 8h1.167v4.083H7.417z" })]
});
export default SvgFilter;
